document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".has-many-container:has(.tableize)").forEach(container => {
        const rows = container?.querySelectorAll(".inputs.has-many-fields")
        const addLink = container?.querySelector("a.has-many-add")
        if (!addLink && !rows) return

        const hasRemoveOrDeleteOption = !!container.querySelector('a.has-many-remove, input[name*="[_destroy]"]')
        const tableHeaders = []

        /**
         * Retrieves table headers from the first row or the addLink dataset.
         * @returns {HTMLTableRowElement} The header row.
         */
        const getHeaders = () => rows.length > 0
            ? createHeaderFromRow(rows[0])
            : createHeaderFromAddLink(addLink)

        const createHeaderFromRow = (row) => {
            const headerRow = document.createElement("tr")
            row.querySelectorAll(".input ol label").forEach(label => {
                tableHeaders.push(label.innerText)
                headerRow.appendChild(
                    createElement("th", {innerText: label.innerText})
                )
            })

            if (hasRemoveOrDeleteOption) {
                tableHeaders.push("")
                headerRow.appendChild(createElement("th", {dataset: {cellRole: "destroy"}})) // Add a column for the remove button
            }

            return headerRow
        }

        const createHeaderFromAddLink = (addLink) => {
            const tempTable = document.createElement("table")
            tempTable.innerHTML = addLink.dataset.html

            const row = tempTable.querySelector(".inputs.has-many-fields")
            return row ? createHeaderFromRow(row) : document.createElement("tr")
        }

        const initializeTable = () => {
            const table = createElement("table", {classList: ["data-table", "tableize"]})

            // Add header row
            const thead = document.createElement("thead")
            thead.appendChild(getHeaders())
            table.appendChild(thead)

            // Add body rows
            const tbody = document.createElement("tbody")
            rows.forEach(row => tbody.appendChild(createTableRow(row)))
            table.appendChild(tbody)

            // Add footer row
            if (addLink) {
                const tfoot = document.createElement("tfoot")
                tfoot.appendChild(createTableFooterRow(addLink))
                table.appendChild(tfoot)
            }

            return table
        }

        const createTableRow = (row) => {
            const bodyRow = document.createElement("tr")
            row.querySelectorAll("li.input[id*=_input]:not(.has-many-delete)").forEach(li => {
                const tempLi = createElement("li", {innerHTML: li.innerHTML})
                if (tempLi.querySelector("label:not(:has(input))"))
                    tempLi.querySelector(".field_with_errors:has(label), label")?.remove()

                const cellInput = tempLi.querySelector("input, select, textarea")
                const cellRole = cellInput.name.split("[").reverse()[0].replace(']', '')
                const cell = createElement("td", {
                    innerHTML: tempLi.innerHTML,
                    classList: li.classList,
                    dataset: {cellRole: cellRole}
                })

                bodyRow.appendChild(cell)
            })

            if (hasRemoveOrDeleteOption) {
                bodyRow.appendChild(createRemoveOrDeleteCell(row))
            }

            return bodyRow
        }

        const createRemoveOrDeleteCell = (row) => {
            if (row.querySelector("a.has-many-remove")) {
                return createRemoveCell(row)
            } else if (row.querySelector("li.has-many-delete")) {
                return createDeleteCell(row)
            }

            return createElement("p")
        }

        const createDeleteCell = (row) => {
            const deleteLi = row.querySelector("li.has-many-delete")
            if (deleteLi)
                return createElement("td", {
                    innerHTML: deleteLi.innerHTML,
                    classList: deleteLi.classList,
                    dataset: {cellRole: "destroy"}
                })

            return null
        }

        const createRemoveCell = (row) => {
            const cell = createElement("td", {dataset: {cellRole: "destroy"}})
            const removeLink = row.querySelector("a.has-many-remove")
            if (removeLink) {
                const newRemoveButton = createRemoveButton(removeLink.innerHTML)
                cell.appendChild(newRemoveButton)
            }

            return cell
        }

        const createRemoveButton = (innerHTML) =>
            createElement("button", {
                innerHTML,
                classList: ["has-many-remove-custom"],
                events: {click: handleRemoveRow}
            })

        const createTableFooterRow = (addLink) => {
            const footerRow = document.createElement("tr")
            const cell = createElement("td", {colSpan: tableHeaders.length, classList: ["text-end"]})
            const buttonContent = document.querySelector('meta[name="localized-add"]')?.getAttribute("content") || addLink.innerHTML

            const newAddButton = createElement("button", {
                innerHTML: buttonContent,
                classList: ["has-many-add-custom", "action-item-button"],
                dataset: {
                    placeholder: addLink.dataset.placeholder,
                    html: createAddRowTemplate().outerHTML
                },
                events: {click: handleAddRow}
            })

            cell.appendChild(newAddButton)
            footerRow.appendChild(cell)
            return footerRow
        }

        const createAddRowTemplate = () => {
            const tempElement = document.createElement("div")
            tempElement.innerHTML = addLink.dataset.html

            const row = tempElement.querySelector(".inputs.has-many-fields")
            const addRow = document.createElement("tr")

            row.querySelectorAll("input, select, textarea").forEach(input => {
                const cellRole = input.name.split("[").reverse()[0].replace(']', '')
                addRow.appendChild(createElement("td", {
                    innerHTML: input.outerHTML,
                    classList: input.parentElement.classList,
                    dataset: {cellRole: cellRole}
                }))
            })

            if (hasRemoveOrDeleteOption) {
                addRow.appendChild(createRemoveCell(row))
            }

            return addRow
        }

        const handleAddRow = (event) => {
            event.preventDefault()
            const tbody = event.target.closest("table").querySelector("tbody")

            const index = parseInt(container.dataset.has_many_index || (tbody.childElementCount - 1), 10) + 1
            container.dataset.has_many_index = index.toString()

            const regex = new RegExp(event.target.dataset.placeholder, "g")
            const newRowHtml = event.target.dataset.html.replace(regex, index)

            const tempTable = document.createElement("table")
            tempTable.innerHTML = newRowHtml

            const newRow = tempTable.querySelector("tr")
            tbody.appendChild(newRow)

            newRow.querySelector(".has-many-remove-custom")?.addEventListener("click", handleRemoveRow)
        }

        const handleRemoveRow = (event) => {
            event.preventDefault()
            const currentRow = event.target.closest("tr")
            if (currentRow) currentRow.remove()
        }

        // Initialize and render the table
        const table = initializeTable()
        container.innerHTML = ""
        container.appendChild(table)

        container.querySelectorAll(".has-many-remove-custom").forEach(link => {
            link.addEventListener("click", handleRemoveRow)
        })
    })
})
